<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/relatorio">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Detalhes</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <span v-for="(item, index) in dataset.data.values" :key="index">
                            <strong>{{ item.column.label }}: </strong> {{ item.value || 'n/a' }}
                            <br />
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: "ReportFileDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        rule: {
            column1: '',
            operator: '',
            column2: ''
        },
        operators: ['+', '-', '*', '/'],
        dataset: {
            reportTypes: [],
            clients: [],
            breadcrumbItems: [],
            loading: false,
            data: {
                file: null
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
        },
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    methods: {

        goBack() {
            this.$router.replace("/relatorio");
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = "Detalhes do relatório";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Relatórios",
                disabled: false,
                to: "/relatorio",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/reports/${this.$route.params.id}`);

                this.dataset.data = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

    },

};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.main-text {
    font-size: 16px;
    color: #000;
}

.caption-text2 {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: -5px;
}

.upload-area {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
    border: 2px dashed var(--v-primary-base);
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
}

.upload-area:hover {
    background-color: #f5f5f5;
}

.upload-area.dragging {
    background-color: #e3f2fd;
}

.upload-icon {
    font-size: 48px;
    color: var(--v-primary-base);
}

.upload-text {
    margin-top: 12px;
    font-size: 16px;
    color: var(--v-primary-base);
}

.v-alert {
    margin-top: 16px;
}
</style>